export { CreateCommunicationPageDesc } from './CreateCommunicationPageDesc';
